import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AddConnection} from '../addConnectionModal/addConnection';
import {MatDialog} from '@angular/material/dialog';
import {GenderFuncService} from '../../../../../core/services/genderFunc.service';
import {FrontUserFormDialogComponent} from '../setting-form/setting-form.component';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {FuseDeleteDialogComponent} from '../../../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService} from 'ngx-toastr';
import { EventService } from '../../../../../core/services/event.service';
import {th} from 'date-fns/locale';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'relative-page',
    templateUrl: './relatives.component.html',
    styleUrls: ['./relatives.component.scss'],
    standalone: false
})

export class RelativesComponent implements OnInit {

  @Input() clanUsers;
  @Input() users;
  @Input() user;
  @Input() type;
  @Input() ageType;
  @Input() role;

  @Output() update = new EventEmitter();
  @Output() updateClan = new EventEmitter();

  constructor(public dialog: MatDialog, public genderService: GenderFuncService,
              public eventService: EventService,
              public userService: FrontUserService, public toastr: ToastrService, public snackBar: MatSnackBar) {
  }

  ngOnInit() {
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  editUser(user) {
    user.connectedUser.genderTypeId = user.genderType ? user.genderType.id : 0;
    user.connectedUser.representative = user.representative ? user.representative : 0;
    let dialogRef = this.dialog.open(FrontUserFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '70vw',
      data: {
        action: 'edit' ,
        type: this.type ,
        data: user.connectedUser ,
        userData: this.user,
        role: user.genderType ? user.genderType.name : '',
        userRole: this.role,
        ageType: this.ageType
      }
    });

    dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response && response[ 1 ] === 'save') {
            response[ 0 ].value.id = user.connectedUser.id;
            if ((+user.connectedUser.genderTypeId !== +response[0].getRawValue().genderType) ||
              (!user.connectedUser.genderTypeId && response[0].getRawValue().genderType) ||
              (!!user.representative !== !!response[0].getRawValue().representative)) {
              let isAdult = response[0].gender.isAdult;
              if (!isAdult && !response[0].gender.isChild) {
                if (this.type === 'student') {
                  isAdult = true;
                }
              }
              let _userCon: any = {
                frontUserId: this.user.id,
                connectedUserId: user.connectedUser.id,
                genderTypeId: response[0].getRawValue().genderType,
                isAdult: isAdult,
                representative: response[0].getRawValue().representative
              };
              if (user.id) {
                _userCon.id = user.id;
              }
              this.genderService.addUserConnection(_userCon).subscribe(result => {
                this.update.emit(true);
                this.updateClan.emit(true);
                let userName = user.connectedUser.firstName + ' ' + user.connectedUser.lastName;
                this.checkParentConnection(this.user.id, user.connectedUser.id, userName);
              });
            }
            if (+this.user.motherId === +response[ 0 ].getRawValue().id) {
              this.userService.deleteUserConnections(this.user.id, 'motherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.fatherId === +response[ 0 ].getRawValue().id) {
              this.userService.deleteUserConnections(this.user.id, 'fatherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.godMotherId === +response[ 0 ].getRawValue().id) {
              this.userService.deleteUserConnections(this.user.id, 'godMotherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.godFatherId === +response[ 0 ].getRawValue().id) {
              this.userService.deleteUserConnections(this.user.id, 'godFatherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            }
            if (+this.user.id === +user.connectedUser.motherId) {
              this.userService.deleteUserConnections(response[ 0 ].getRawValue().id, 'motherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.id === +user.connectedUser.fatherId) {
              this.userService.deleteUserConnections(response[ 0 ].getRawValue().id, 'fatherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.id === +user.connectedUser.godMotherId) {
              this.userService.deleteUserConnections(response[ 0 ].getRawValue().id, 'godMotherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            } else if (+this.user.id === +user.connectedUser.godFatherId) {
              this.userService.deleteUserConnections(response[ 0 ].getRawValue().id, 'godFatherId').subscribe(r => {
                this.updateClan.emit(true);
              });
            }
            let updatedUser = response[ 0 ].getRawValue();
            if (user.id) {
              updatedUser.id = user.connectedUser.id;
            }
            this.userService.addUser(updatedUser).subscribe((res: any) => {
              if (res) {
                this.update.emit(true);
                // let userName = user.connectedUser.firstName + ' ' + user.connectedUser.lastName;
                // this.checkParentConnection(this.user.id, user.connectedUser.id, userName);
              }
            });
        }
      });
  }

  removeUser(id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' , height: 'auto',
      data: {title: 'remove_relation_title' , message: 'remove_relation_text'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.genderService.deleteUserConnections(id).subscribe((res) => {
          this.toastr.success('Benutzerbeziehung entfernt', 'Success!');
          this.update.emit(true);
          this.updateClan.emit(true);
        });
      }
    });
  }

  removeClanUser(user) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' , height: 'auto',
      data: {title: 'remove_relation_title' , message: 'remove_relation_text'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let type = user.genderType ? user.genderType.defaultType + 'Id' : '';
        this.userService.deleteUserConnections(this.user.id, type).subscribe((res) => {
          this.toastr.success('Benutzerbeziehung entfernt', 'Success!');
          this.update.emit(true);
          this.updateClan.emit(true);
        });
      }
    });
  }

  createConnection(user) {
    let userName = user.connectedUser.firstName + ' ' + user.connectedUser.lastName;
    let dialogRef = this.dialog.open(AddConnection , {
      panelClass: 'contact-form-dialog' ,
      width: '500px',
      data: {
        userName: userName ,
        type: user.genderType ? user.genderType.id : '',
        countType: 'one',
        currentUserName: this.user.firstName + ' ' + this.user.lastName,
        userType: this.type
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        let isAdult = res.isAdult;
        if (!isAdult && !res.isChild) {
          if (this.type === 'student') {
            isAdult = false;
          } else if (this.user?.frontRoleId === 2 && user?.connectedUser?.frontRoleId === 2) {
            isAdult = true;
          }
        }
        let _userCon = {
          frontUserId: user.connectedUser.id,
          connectedUserId: this.user.id,
          genderTypeId: res.id,
          isAdult: isAdult
        };
        this.genderService.addUserConnection(_userCon).subscribe(result => {
          this.update.emit(true);
          this.updateClan.emit(true);
        });
      }
    });
  }


  checkParentConnection(userId, connectedUserId, userName) {
    this.userService.checkParentConnection(userId, connectedUserId).subscribe((res: any) => {
      if (res && res.length) {
        this.createManyConnection(res, userName);
      }
    });
  }

  createManyConnection(users, userName) {
    let dialogRef = this.dialog.open(AddConnection , {
      panelClass: 'contact-form-dialog' ,
      width: '500px',
      data: {
        users: users,
        countType: 'many',
        userName,
        userType: this.type
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        let keys = Object.keys(res);
        if (keys && keys.length) {
          let resArr = [];
          for (let i = 0; i < keys.length; i++) {
            let isAdult = res[keys[i]].isAdult;
            if (!isAdult && !res[keys[i]].isChild) {
              if (this.type === 'student') {
                isAdult = false;
              }
            }
            let _userCon = {
              frontUserId: this.user.id,
              connectedUserId: +keys[i],
              genderTypeId: res[keys[i]].id,
              isAdult: isAdult
            };
            resArr.push(_userCon);
          }
          this.genderService.addUserConnection(resArr).subscribe(result => {
            this.update.emit(true);
          });
        }
      }
    });
  }
}
